<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px">
  <div class="content container-fluid">
    <div class="col col-xs-12">
      <div class="row row-replace add-m-b">
        <div class="col-md-6 col-9 col-p h5">
          <i class="fa fa-user-md"></i> Workplace Permission Application Form
        </div>
        <div class="col-md-6 col-3 top-corner-items col-p">
          <span class="home-1"  (click)="back()">
            <i class="fa fa-home ml-3" style="font-size:37px"></i>
          </span>
        </div>
      </div>
      <div class="row row-replace m-t-30">
        <div class="col-md-12">
          <p class="text-danger">
            The Workplace Permission application process has been implemented
            basis on Mobilisehealth and safety environment HSE guidelines taking
            into account to meet the mutual responsibilities and reasonable care
            to protect the health and safety of our employees and others in the
            workplace.
          </p>
        </div>
      </div>
      <div class="row row-replace m-t-30">
        <div class="col-md-12">
          <p class="text-danger">*Note :You can apply maximum 7 days.</p>
        </div>
      </div>
      <div class="content_area">
        <div class="row">
          <div class="col-md-12">
            <div class="col-lg-12">
              <form
                [formGroup]="permissionForm"
                (ngSubmit)="submitPermission()"
              >
                <div class="row">
                  <div class="col-md-6 d-flex padding-right-2 padding-left-2">
                    <div class="card flex-fill add-mrf-card">
                      <div class="card-body card-padding-bottom">
                        <h3 class="card-title page-header0">
                          <i class="fa fa-info-circle"></i>&nbsp;
                          <b>Basic Information</b>
                        </h3>
                        <hr class="row-bdr" />
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Employee Name</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="emp_name"
                              formControlName="emp_nm"
                              readonly
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Cost Center</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="emp_name"
                              formControlName="cc"
                              readonly
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Designation</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="text"
                              class="form-control"
                              formControlName="desig"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Department</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="text"
                              class="form-control"
                              formControlName="depart"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Reporting Manager</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="text"
                              class="form-control"
                              formControlName="rm"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Mobile</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="text"
                              class="form-control"
                              formControlName="mobile"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Visiting Office<span class="form-error"
                              >*</span
                            ></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <select
                              class="form-control"
                              formControlName="visiting_office"
                              (change)="changeOffice()"
                            >
                              <option value="">Select</option>
                              <option
                                value="{{ data.value }}"
                                *ngFor="let data of visitOffice"
                              >
                                {{ data.label }}
                              </option>
                            </select>
                            <div
                              *ngIf="submit && f.visiting_office.errors"
                              class="form-error"
                            >
                              <div *ngIf="f.visiting_office.errors.required">
                                Please Select Office !
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Start Date of visiting office
                            <span class="form-error">*</span></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="date"
                              class="form-control"
                              formControlName="start_date_of_visit"
                              [min]="today"
                              [max]="maxDate"
                              (change)="fromDateChange()"
                            />
                            <div
                              *ngIf="submit && f.start_date_of_visit.errors"
                              class="form-error"
                            >
                              <div
                                *ngIf="f.start_date_of_visit.errors.required"
                              >
                                Date is required !
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >In Time of visiting office
                            <span class="form-error">*</span></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <select
                              class="form-control"
                              formControlName="in_time_of_visit"
                              (change)="inTimeChange($event)"
                            >
                              <option
                                *ngFor="let item of timeSlots"
                                value="{{ item.value }}"
                              >
                                {{ item.label }}
                              </option>
                            </select>
                            <!-- <input type="time" class="form-control" formControlName="in_time_of_visit" (change)="inTimeChange($event)"/> -->
                            <div
                              *ngIf="submit && f.in_time_of_visit.errors"
                              class="form-error"
                            >
                              <div *ngIf="f.in_time_of_visit.errors.required">
                                Time is required !
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >End Date of visiting office<span class="form-error"
                              >*</span
                            ></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="date"
                              class="form-control"
                              formControlName="end_date_of_visit"
                              [min]="start_date_of_visit"
                              [max]="maxDate"
                              (change)="endDateChange()"
                            />
                            <div
                              *ngIf="submit && f.end_date_of_visit.errors"
                              class="form-error"
                            >
                              <div *ngIf="f.end_date_of_visit.errors.required">
                                Date is required !
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Out Time of visiting office<span class="form-error"
                              >*</span
                            ></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <select
                              class="form-control"
                              formControlName="out_time_of_visit"
                              (change)="checkCapacity()"
                            >
                              <option
                                *ngFor="let item of endTime"
                                value="{{ item.value }}"
                              >
                                {{ item.label }}
                              </option>
                            </select>
                            <!-- <input type="time" class="form-control" formControlName="out_time_of_visit" max={{maxTime}} (change)="checkCapacity()"/> -->
                            <div
                              *ngIf="submit && f.out_time_of_visit.errors"
                              class="form-error"
                            >
                              <div *ngIf="f.out_time_of_visit.errors.required">
                                Time is required !
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="alert alert-{{ alrtColor }}" *ngIf="hasMsg">
                          <!-- <strong>{{alrtColor | uppercase}}!</strong> {{capacityMsg}}. -->
                          <div [innerHTML]="capacityMsg"></div>
                        </div>
                        <div *ngIf="hasCapacity">
                          <button
                            *ngIf="fixedSeat == false"
                            type="button"
                            class="btn btn-primary btn-sm m-r-5"
                            (click)="bookDeskModal('#book_desk', 0)"
                          >
                            Book Your Desk
                            <span *ngIf="selectedSeat">
                              - Selected Desk : {{ selectedSeat }}
                            </span>
                          </button>

                          <button
                            *ngIf="fixedSeat == true"
                            type="button"
                            class="btn btn-primary btn-sm m-r-5"
                          >
                            Your fixed
                            <span *ngIf="fixedSeatNo">
                              - Desk : {{ fixedSeatNo }}
                            </span>
                          </button>

                          <button
                            type="button"
                            class="btn btn-primary btn-sm m-r-5"
                            (click)="bookDeskModal('#book_desk', 1)"
                            *ngIf="isMtngRoomallw"
                          >
                            Book Meeting Room
                            <span *ngIf="mtng_room_id">
                              - Selected Room : {{ mtng_room_id }}
                            </span>
                          </button>
                        </div>

                        <div class="row m-t-10" *ngIf="mtng_room_id">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Meeting Room Capacity</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="number"
                              class="form-control"
                              readonly
                              formControlName="mtng_room_cpcty"
                            />
                          </div>
                        </div>
                        <div class="row m-t-10" *ngIf="mtng_room_id">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Minimum Booking Required</label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="number"
                              class="form-control"
                              readonly
                              formControlName="mtng_room_capping"
                            />
                          </div>
                        </div>

                        <div
                          class="row row-replace m-t-10"
                          *ngIf="mtng_room_id && visitors.length > 0"
                        >
                          <div class="col-md-12">
                            <h4 class="text-center"><b> Visitors</b></h4>
                            <div class="table-responsive">
                              <table class="table table-striped mb-0">
                                <thead>
                                  <tr>
                                    <th>Employee Name</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let data of visitors">
                                    <td>
                                      {{ data.username }} - {{ data.name }}
                                    </td>
                                    <td>
                                      <button
                                        class="btn-sm btn btn-danger"
                                        (click)="deleteVisitor(data)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div
                          class="row m-t-10"
                          [hidden]="
                            !mtng_room_id ||
                            mtng_room_cpcty == 0 ||
                            mtng_room_cpcty == ''
                          "
                        >
                          <label class="col-form-label col-md-4 col-sm-4">
                            Search Visitors
                          </label>
                          <div class="col-md-8 col-sm-8">
                            <input
                              list="emp_search"
                              #itemSearchInput
                              formControlName="emp_id"
                              autocomplete="off"
                              class="form-control"
                              placeholder="Employee Search"
                            />
                            <select
                              class="form-control"
                              (change)="selectEmp($event)"
                              *ngIf="searchEmps.length > 0 && emp_id"
                            >
                              <option value="">Select</option>
                              <option
                                [value]="list.id"
                                *ngFor="let list of searchEmps"
                              >
                                {{ list.username }} - {{ list.name }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="row m-t-10">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Age <span class="form-error">*</span></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <input
                              type="number"
                              class="form-control"
                              formControlName="age"
                            />
                            <div
                              *ngIf="submit && f.age.errors"
                              class="form-error"
                            >
                              <div *ngIf="f.age.errors.required">
                                Age is required !
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-4 col-sm-4"
                            >Residence address
                            <span class="form-error">*</span></label
                          >
                          <div class="col-md-8 col-sm-8">
                            <textarea
                              class="form-control"
                              rows="3"
                              placeholder="Address...."
                              formControlName="residence_address"
                            ></textarea>
                            <div
                              *ngIf="submit && f.residence_address.errors"
                              class="form-error"
                            >
                              <div *ngIf="f.residence_address.errors.required">
                                Address is required !
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-md-6 d-flex padding-right-2 padding-left-2">
                    <div class="card flex-fill add-mrf-card">
                      <div class="card-body card-padding-bottom">
                        <h3 class="card-title page-header0">
                          <i class="fa fa-question-circle"></i>&nbsp;
                          <b>Questionnaire</b>
                        </h3>
                        <hr class="row-bdr" />
                        <span *ngFor="let qus of k.controls; let i = index">
                          <div class="row" [formGroup]="qus">
                            <label class="col-form-label col-md-8 col-sm-8"
                              ><b>{{ i + 1 }}.</b>
                              {{ qus.controls.optn_desc.value
                              }}<span class="form-error">*</span></label
                            >
                            <div class="col-md-4 col-sm-4">
                              <div class="col-md-12 col-sm-12 pt-10">
                                <div class="form-check form-check-inline">
                                  <input
                                    class="form-check-input"
                                    formControlName="optn_respnse"
                                    type="radio"
                                    value="1"
                                  />
                                  <label class="form-check-label">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                  <input
                                    class="form-check-input"
                                    formControlName="optn_respnse"
                                    type="radio"
                                    value="0"
                                  />
                                  <label class="form-check-label">No</label>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  submit && qus.controls.optn_respnse.errors
                                "
                                class="form-error"
                              >
                                <div
                                  *ngIf="
                                    qus.controls.optn_respnse.errors.required
                                  "
                                >
                                  Answer is required !
                                </div>
                              </div>
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div> -->

                  <div class="col-md-6 d-flex padding-right-2 padding-left-2">
                    <div class="card flex-fill add-mrf-card">
                      <div class="card-body card-padding-bottom">
                        <h3 class="card-title page-header0">
                          <i class="fa fa-commenting-o"></i>&nbsp;
                          <b>Description</b>
                        </h3>
                        <hr class="row-bdr" />
                        <div class="row">
                          <label class="col-form-label col-md-6 col-sm-6"
                            >Want to upload any certificate?</label
                          >
                          <div class="col-md-6 col-sm-6">
                            <input
                              type="file"
                              class="form-control"
                              (input)="onUploadAttach1($event, 3)"
                            />
                          </div>
                          <p class="text-danger m-r-5">
                            You can only upload one PDF document. Hence please
                            create one PDF document for all pdf reports.
                          </p>
                        </div>
                        <div class="row">
                          <label class="col-form-label col-md-6 col-sm-6"
                            >Please share any other details (if any) ?</label
                          >
                          <div class="col-md-6 col-sm-6">
                            <textarea
                              class="form-control"
                              rows="3"
                              placeholder="Details...."
                              formControlName="remark"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                    <div class="card flex-fill add-mrf-card">
                      <div class="card-body card-padding-bottom">
                        <h3 class="card-title page-header0">
                          <i class="fa fa-pencil-square"></i>&nbsp;
                          <b>Terms and Conditions</b>
                        </h3>
                        <hr class="row-bdr" />
                        <div class="row">
                          <div class="col-md-12 col-sm-8">
                            <ul style="list-style-type: unset">
                              <li>
                                I certify that the information provided by me is
                                complete and correct to the best of my knowledge
                                and belief.
                              </li>
                              <li>
                                I understand that any misrepresentation made on
                                this Form will result in disciplinary action.
                              </li>
                              <li>
                                I agree to display the E-Copy of the form on
                                request of the authorized personnel of company.
                              </li>
                              <li>
                                I Agree to accept and follow the HSE security
                                /administration standards set by MobiliseIndia to
                                have safe workplace environment.
                              </li>
                              <li>
                                Human Resources/ Employee Services team reserves
                                the right to request additional supporting
                                documentation.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-2 col-sm-2">
                            <input
                              type="checkbox"
                              class="form-control"
                              [(ngModel)]="isAccepted"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="checkUncheck($event)"
                            />
                          </div>
                          <label
                            class="col-form-label col-md-10 col-sm-10 text-danger"
                            >Please accept the above terms & conditions
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section
                  class="row d-flex justify-content-center pt-10"
                  *ngIf="hasCapacity"
                >
                  <button
                    type="submit"
                    class="btn btn-primary btn-sm m-r-5"
                    [disabled]="!isAccepted"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    (click)="reset()"
                  >
                    Reset
                  </button>
                </section>
                <footer class="row">&nbsp;</footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /Page Wrapper -->

<div
  id="book_desk"
  class="modal custom-modal fade"
  data-backdrop="static"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Desk Booking</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row row-replace m-t-30">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-8">
                <div class="text-center p-10">
                  <span style="font-size: 16px"
                    ><i class="fa fa-square" style="color: #214e26"></i> Active
                    Seats
                  </span>
                  <span style="font-size: 16px"
                    ><i class="fa fa-square" style="color: #ffbc34"></i> Fixed
                    Seats
                  </span>
                  <span style="font-size: 16px"
                    ><i class="fa fa-square" style="color: #dc3545"></i> Hot
                    Seats
                  </span>
                  <span style="font-size: 16px"
                    ><i class="fa fa-square" style="color: #6c757d"></i>
                    Disabled Seats
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <p>
                  <b>Selected Desk - {{ selectedSeat }}</b>
                </p>
                <p>
                  <b>Selected Meeting Room - {{ mtng_room_id }}</b>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 custmScroll">
            <div
              [ngStyle]="{ 'background-image': 'url(' + floor_img + ')' }"
              style="
                width: 600px;
                height: 1900px;
                margin: 0 auto;
                background-repeat: no-repeat;
                background-size: 100%;
              "
              class="zoom"
            >
              <button
                class="btn btn-sm setAv"
                *ngFor="let x of seats; let i = index"
                [ngStyle]="{ margin: x.xy }"
                [disabled]="x.is_disabled"
                (click)="selectSeat(x)"
                [ngClass]="{
                  'btn-warning': x.is_fixed,
                  'btn-secondary': x.is_disabled,
                  'btn-danger': x.is_flexible_seat == 1
                }"
              >
                {{ x.seat_id }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
